__turbopack_context__.v({
  "badge": "all-in-one-calculator-module__qb624a__badge",
  "badge-electricity": "all-in-one-calculator-module__qb624a__badge-electricity",
  "badge-gas": "all-in-one-calculator-module__qb624a__badge-gas",
  "card": "all-in-one-calculator-module__qb624a__card",
  "checkouts-disabled": "all-in-one-calculator-module__qb624a__checkouts-disabled",
  "confirmation-row": "all-in-one-calculator-module__qb624a__confirmation-row",
  "input-grid": "all-in-one-calculator-module__qb624a__input-grid",
  "input-row-2": "all-in-one-calculator-module__qb624a__input-row-2",
  "input-row-3": "all-in-one-calculator-module__qb624a__input-row-3",
  "section": "all-in-one-calculator-module__qb624a__section",
  "teaser-content": "all-in-one-calculator-module__qb624a__teaser-content",
  "teaser-image": "all-in-one-calculator-module__qb624a__teaser-image",
  "unit": "all-in-one-calculator-module__qb624a__unit",
});
